import { Directive, HostListener, inject, input } from '@angular/core';
import { Analytics } from './analytics.service';
import { AnalyticsEvent } from '@gains-com/shared';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[trackEvent]',
})
export class AnalyticsDirective {
  readonly eventName = input<AnalyticsEvent>(undefined, { alias: "trackEvent" });
  readonly pageArea = input<string>();
  readonly trackEventParams = input({});
  private readonly _analytics = inject(Analytics);

  /* eslint-disable camelcase */
  @HostListener('click')
  trackEvent(): void {
    const pageArea = this.pageArea();
    this._analytics.trackEvent(this.eventName(), {
      ...this.trackEventParams(),
      ...(pageArea ? { page_area: pageArea } : {}),
    });
  }
}
